import { useMonitor } from '../use-monitor';

export function useMonitorDeclineActionLoad() {
  return useMonitor('decline-action-load');
}
